<template>
  <div class="view">
    <hgroup>
      <h1>Nyt hold</h1>
      <h3 class="color-tint">Udfyld felterne herunder</h3>
    </hgroup>
    <validator name="validation">
      <form novalidate :class="classes">
        <!-- Name -->
        <div class="field">
          <label for="team-name">Holdnavn</label>
          <input type="text" v-model="name" v-validate:name="{ minlength: 3, required: true }" id="team-name">
        </div>

        <!-- Description -->
        <div class="field">
          <label for="team-description">Beskrivelse</label>
          <textarea v-model="description" id="team-description"></textarea>
        </div>

        <!-- Additional packages -->
        <!--
        <div class="field">
          <h2>Evaluering</h2>
          <p>Her skal du vælge hvilken evalueringsskema, der bliver udsendt før og efter et træningsforløb.</p>
          <div class="input-group input-group-radio">
            <div class="input" v-for="(key, label) in surveyTypes">
              <input type="radio" name="type" v-model="type" :value="key" :id="'type_field_' + key">
              <label :for="'type_field_' + key">{{label}}</label>
            </div>
          </div>
        </div>
        -->

        <!-- Predfined exercises -->
        <div class="field" v-if="predefined">
          <h2>Prædefinerede træningsprogrammer</h2>
          <p>Du kan vælge at tage udgangspunkt i følgende træningsprogrammer</p>
          <div class="input-group input-group-radio">
            <div class="input">
              <input type="radio" name="predefinedType" v-model="predefinedType" value="none" checked>
              <label for="predefinedType">Ingen</label>
            </div>
            <div class="input" v-for="item in predefined">
              <input type="radio" name="predefinedType" v-model="predefinedType" :value="item.id">
              <label for="predefinedType">{{item.title}}</label>
            </div>
          </div>
        </div>

        <!-- Add attendee -->
        <div class="field">
           <validator name="attendee">
            <form novalidate>
              <div class="input-group">
                <div class="field">
                  <label for="attendee-name">Deltager</label>
                  <input v-model="attendee" v-validate:attendee="{ required: true }" v-on:keyup.enter="addAttendee" type="text" id="attendee-name">
                </div>
                <div class="field">
                  <label for="attendee-mail">Mail</label>
                  <input v-model="mail" v-validate:mail="['required', 'email']" v-on:keyup.enter="addAttendee" type="text" id="attendee-mail">
                </div>
                <div class="field">
                  <label for="attendee-survey-type">Evaluering</label>
                  <select v-model="survey_type" v-on:keyup.enter="addAttendee" id="attendee-survey-type">
                    <option value="">-- ingen --</option>
                    <option v-for="(key, label) in surveyTypes" :value="key">{{label}}</option>
                  </select>
                </div>
              </div>
              <div class="button" v-if="$attendee.valid" @click="addAttendee">Tilføj deltager</div>
            </form>
          </validator>

          <!-- Rendered attendees -->
          <table-data
            :data="attendeesDisplay"
            :columns="tableColumns"
            @remove="onRemove">
          </table-data>

        </div>

        <!-- Errors -->
        <div class="errors">
          <p v-if="$validation.name.required">Udfyld holdnavn.</p>
          <p v-if="$validation.name.minlength">Holdnavn skal være på minimum tre karakterer.</p>
          <!--<p v-if="attendees.length === 0">Der skal være deltagere på holdet.</p>-->
        </div>

        <!-- Add team -->
        <button type="button" class="button" v-if="$validation.valid" @click="submit">Tilføj hold</button>
      </form>
    </validator>
  </div>
</template>

<script>
import view from '../mixins/view'

// Actions
import { newTeam } from 'state/teams/actions'

// Resources
import { PredefinedExercises, SurveyTypes } from 'api/resources'
import { host } from 'src/api/resources'

// Components
import TableData from 'components/TableData'

export default {
  name: 'NewTeam',
  mixins: [view],
  vuex: {
    actions: {
      newTeam
    }
  },
  components: {
    TableData
  },
  data () {
    return {
      name: '',
      description: '',
      attendees: [],
      sending: false,
      attendee: '',
      mail: '',
      survey_type: '',
      // type: 'none',
      host,
      predefinedType: 'none',
      tableColumns: [
        {
          key: 'name',
          name: 'Navn',
          sort: true
        },
        {
          key: 'email',
          name: 'Mail',
          sort: true
        },
        {
          key: 'survey_type',
          name: 'Evaluering',
          sort: true
        }
      ]
    }
  },
  computed: {
    classes () {
      return {
        disabled: this.sending
      }
    },
    request () {
      return {
        name: this.name,
        description: this.description,
        attendees: this.attendees,
        // type: this.type,
        exercise_group: this.predefinedType
      }
    },
    attendeesDisplay () {
      let display = JSON.parse(JSON.stringify(this.attendees)) // clone attendees so we don't modify the original Vue data
      return display.map((attendee) => Object.assign({}, attendee,  {
        survey_type: attendee.survey_type === '' ? '-- ingen --' : this.surveyTypes[attendee.survey_type]
      }))
    }
  },
  asyncComputed: {
    predefined () {
      return PredefinedExercises.get()
      .then(response => response.data)
    },
    surveyTypes () {
      return SurveyTypes.get()
      .then(response => response.data)
    }
  },
  methods: {
    submit () {
      this.sending = true
      this.newTeam(this.request).then(() => {
        this.sending = false
        this.$router.go({name: 'teams'})
      }).catch((error) => {
        console.log('an error occured', error)
      })
    },
    addAttendee () {
      if (!this.$attendee.valid) {
        alert('Alle felter for navn, e-mail og evaluering skal udfyldes')
        return
      }
      this.attendees.push({
        name: this.attendee,
        email: this.mail,
        survey_type: this.survey_type,
        remove: this.removeAttendee,
        callback: function () {
          this.remove(this)
        }
      })
      this.attendee = ''
      this.mail = ''
      this.survey_type = ''
    },
    removeAttendee (attendee) {
      this.attendees.splice(this.attendees.indexOf(attendee), 1)
    },
    onRemove (index) {
      this.attendees.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.errors {
  font-size: 18px;
  opacity: .25;
}
hgroup {
  text-align:center;
  margin-top: 4em;
}

table {
  margin-top: 2rem;
}

form {
  margin: 4em auto;
  padding: 3em 2em 2em 2em;
  background: #fafafa;

  &.disabled {
    color: white;
    pointer-events: none;
    -webkit-filter: grayscale(1);
    opacity: .25;
  }
}

.button {
  position: relative;
  display: inline-block;
  padding: 12px 24px;
  margin: .3em 0 1em 0;
  width: 100%;
  vertical-align: middle;
  color: #fff;
  font-size: 16px;
  line-height: 20px;
  -webkit-font-smoothing: antialiased;
  text-align: center;
  letter-spacing: 1px;
  background: transparent;
  border: 0;
  cursor: pointer;
  background: blue;
}
.button:focus { outline: 0; }

input[type="radio"] + label {
  display: inline-flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// NewTeam.vue?44b2a7c8